/**
 * Welke tak van de gegevenspagina krijgt de deelnemer te zien?
 *
 * Deze beslissing staat hier los, en niet als voorwaarde middenin de JSX, om twee
 * redenen. Ten eerste is hij zo te testen zonder een browser op te tuigen. Ten tweede
 * nemen twee schermen dezelfde beslissing — `GegevensPage` (welke tak toon ik?) en
 * `BaselinePage` (moet ik doorsturen?) — en twee kopieën van zo'n keuze lopen uit de
 * pas zodra er een derde uitkomst bij komt. Dat is precies wat er gebeurde: de keuze
 * "nu invullen / liever later" werd óók getoond aan iemand die de nulmeting allang had
 * ingevuld, en die liep daarna op een foutmelding vast.
 *
 * Deze functie rekent NIETS na. Hij leest `compleet` en `nulmeting_ingevuld` zoals de
 * server ze geeft. De compleetheidsregel zelf staat op precies één plek, in
 * `backend/app/services/gegevens_compleet.py`; een tweede versie in JavaScript zou de
 * kopie zijn die we juist vermijden.
 */

/** Zolang het antwoord van de server nog onderweg is, valt er niets te beslissen. */
export const AAN_HET_LADEN = "laden";
/** Er ontbreekt nog iets: eerst aanvullen. */
export const INCOMPLEET = "incompleet";
/** Alles staat er: nu invullen of liever later. */
export const KEUZE = "keuze";
/** De nulmeting is al ingevuld: geen keuze meer, een afsluitende regel. */
export const AL_INGEVULD = "al_ingevuld";

/**
 * @param {object|null|undefined} gegevens  het antwoord van GET /werknemer/{sleutel}/gegevens
 * @returns {"laden"|"incompleet"|"keuze"|"al_ingevuld"}
 */
export function bepaalGegevensWeergave(gegevens) {
  // Geen antwoord (nog niet binnen, of een fout): niets beslissen en zeker niet
  // doorsturen. Zou hier `incompleet` uitkomen, dan stuurt `BaselinePage` door naar de
  // gegevenspagina, die op zijn beurt weer terugstuurt — het pingpong dat we niet willen.
  if (!gegevens || typeof gegevens !== "object") return AAN_HET_LADEN;

  // Wie de vragenlijst al invulde, hoort de keuze niet meer te zien: beide knoppen
  // lopen voor hem dood (de vragenlijst geeft 409, "liever later" ook). Dit gaat vóór
  // de compleetheid: iemand kan zijn nulmeting hebben ingevuld en later een veld zijn
  // kwijtgeraakt, en dan is "vul eerst uw gegevens aan" een zinloze opdracht.
  if (gegevens.nulmeting_ingevuld === true) return AL_INGEVULD;

  if (gegevens.compleet === true) return KEUZE;
  return INCOMPLEET;
}
